import { saveItemSmell, fetchAllItemSmells, fetchItemSmellsByItemId } from '@/api/item-smell.api'
import Vue from 'vue'

const state = {
    fetchingItemSmells: true,
    itemSmells: [],
    itemSmellsByItem: {},
    fetchingItemSmellsByItem: {}
}

const getters = {
    isFetchingItemSmells: state => state.fetchingItemSmells,

    getitemSmells: state => state.itemSmells,

    getItemSmellsByItem: state => itemId => state.itemSmellsByItem[itemId] || [],

    isFetchingItemSmellsByItem: state => itemId => state.fetchingItemSmellsByItem[itemId] || false
}

const actions ={
    async saveItemSmell({ dispatch }, request) {
        await saveItemSmell(request)
            .then(() => {
                Vue.notify({
                    group: 'success',
                    text: 'Miris je uspesno sacuvan'
                })
                dispatch('fetchAllItemSmells')
            }).catch(() => {
                Vue.notify({
                    group: 'errors',
                    title: 'Greška na serveru',
                    text: 'Doslo je do greske na serveru, molimo vas pokusajte kasnije'
                })
            })
    },

    async fetchAllItemSmells({ commit }) {
        commit('setFetchingItemSmells', true)
        const response = await fetchAllItemSmells()
        commit('setItemSmells', response.data)
        commit('setFetchingItemSmells', false)
    },

    async fetchItemSmellsByItemId({ commit }, itemId) {
        commit('setFetchingItemSmellsByItem', { itemId, fetching: true })
        try {
            const response = await fetchItemSmellsByItemId(itemId)
            commit('setItemSmellsByItem', { itemId, smells: response.data })
        } catch (error) {
            commit('setItemSmellsByItem', { itemId, smells: [] })
        }
        commit('setFetchingItemSmellsByItem', { itemId, fetching: false })
    }
}

const mutations = {
    setFetchingItemSmells: (state, fetchingItemSmells) => state.fetchingItemSmells = fetchingItemSmells,

    setItemSmells: (state, itemSmells) => state.itemSmells = itemSmells,

    setItemSmellsByItem: (state, { itemId, smells }) => {
        Vue.set(state.itemSmellsByItem, itemId, smells)
    },

    setFetchingItemSmellsByItem: (state, { itemId, fetching }) => {
        Vue.set(state.fetchingItemSmellsByItem, itemId, fetching)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
